import { useContext } from 'react';
import { DynamicReportsContext } from './dynamicReportsProvider';

export function useDynamicReportsConfig() {
  const dynamicReportsCtx = useContext(DynamicReportsContext);
  return dynamicReportsCtx;
}
